<div class="max-w-4xl mx-auto px-4 py-12">
  <div class="prose max-w-none">
    <h1 class="text-4xl font-bold mb-6">Política de Privacidade</h1>

    <p class="text-gray-600 mb-8">
      <strong>Data de Atualização:</strong> {{ currentYear }}<br>
      <strong>Última Revisão:</strong> {{ currentYear }}
    </p>

    <div class="border border-gray-200 rounded-xl p-6 mb-10 bg-white shadow-sm">
      <h2 class="text-xl font-semibold mb-4">Sumário</h2>
      <div class="toc-grid grid gap-2 sm:grid-cols-2">
        <a class="text-blue-700 hover:text-blue-900 transition" href="#introducao">1. Introdução</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#dados">2. Dados Pessoais Coletados</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#finalidades">3. Finalidades de Processamento</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#base-legal">4. Base Legal</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#compartilhamento">5. Compartilhamento de Dados</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#retencao">6. Retenção de Dados</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#protecao">7. Proteção de Dados</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#transferencia">8. Transferência Internacional</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#cookies">9. Cookies</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#direitos">10. Direitos LGPD</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#consentimento">11. Consentimento</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#menores">12. Menores de Idade</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#contato">13. Contato e DPO</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#modificacoes">14. Modificações da Política</a>
        <a class="text-blue-700 hover:text-blue-900 transition" href="#lei">15. Lei Aplicável</a>
      </div>
    </div>

    <section id="introducao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">1. Introdução</h2>
      <p class="mb-4">
        A presente Política de Privacidade ("Política") estabelece como coletamos, utilizamos, armazenamos e protegemos
        os dados pessoais dos usuários da plataforma de concursos públicos ("Plataforma"). Compreendemos a importância da
        privacidade e nos comprometemos em proteger suas informações pessoais de forma responsável e em conformidade com
        a legislação brasileira, em especial a Lei Geral de Proteção de Dados Pessoais (LGPD - Lei nº 13.709/2018).
      </p>
    </section>

    <section id="dados" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">2. Dados Pessoais Coletados</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">2.1 Dados Fornecidos Diretamente pelo Usuário</h3>
        <p class="mb-4">Durante o cadastro e uso da Plataforma, coletamos os seguintes dados:</p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li><strong>Identificação Pessoal:</strong> Nome completo, data de nascimento, nacionalidade, estado civil</li>
          <li><strong>Dados de Contato:</strong> Endereço de e-mail, telefone, enderço residencial e comercial</li>
          <li><strong>Documentação:</strong> Número de CPF, RG, PIS/PASEP e outros documentos de identificação</li>
          <li><strong>Informações Profissionais:</strong> Histórico educacional, experiência profissional, qualificações</li>
          <li><strong>Dados Financeiros:</strong> Informações bancárias (somente quando necessário para pagamentos)</li>
          <li><strong>Dados de Autenticação:</strong> Senha, respostas de segurança, dados biométricos (se aplicável)</li>
          <li><strong>Dados de Inscrição:</strong> Informações sobre concursos em que você se inscreveu</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">2.2 Dados Coletados Automaticamente</h3>
        <p class="mb-4">
          Também coletamos certos dados automaticamente quando você usa a Plataforma:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li><strong>Dados de Uso:</strong> Páginas visitadas, tempo gasto, cliques, movimentos do cursor</li>
          <li><strong>Dados Técnicos:</strong> Endereço IP, tipo de navegador, sistema operacional, resolução de tela</li>
          <li><strong>Dados de Dispositivo:</strong> Identificadores de dispositivo, informações de hardware</li>
          <li><strong>Cookies e Tecnologias Similares:</strong> Identificadores únicos para rastrear preferências</li>
          <li><strong>Dados de Localização:</strong> Localização geográfica aproximada (se autorizada)</li>
          <li><strong>Logs de Acesso:</strong> Data e hora de acesso, atividades realizadas na Plataforma</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">2.3 Dados Coletados de Terceiros</h3>
        <p class="mb-4">
          Podemos receber dados seus de terceiros, como:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Organizadoras de concursos públicos</li>
          <li>Órgãos governamentais e entidades públicas</li>
          <li>Provedores de serviços de verificação de identidade</li>
          <li>Plataformas de redes sociais (se você optar por fazer login social)</li>
        </ul>
      </div>
    </section>

    <section id="finalidades" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">3. Finalidades de Processamento de Dados</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">3.1 Prestação de Serviços</h3>
        <p class="mb-4">
          Utilizamos seus dados pessoais para:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Criar e gerenciar sua conta na Plataforma</li>
          <li>Processar inscrições em concursos públicos</li>
          <li>Validar seus dados e verificar sua identidade</li>
          <li>Realizar pagamento de taxas de inscrição</li>
          <li>Comunicar sobre o status de suas inscrições e resultados</li>
          <li>Fornecer suporte técnico e ao cliente</li>
          <li>Enviar documentos e confirmações relacionados a concursos</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">3.2 Melhoria de Serviços</h3>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Analisar o uso da Plataforma para identificar melhorias</li>
          <li>Realizar pesquisas e estudos de satisfação</li>
          <li>Personalizar sua experiência na Plataforma</li>
          <li>Testar novas funcionalidades</li>
          <li>Otimizar a performance da Plataforma</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">3.3 Conformidade Legal e Segurança</h3>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Cumprir obrigações legais e regulatórias</li>
          <li>Prevenir, detectar e investigar fraudes</li>
          <li>Proteger contra atividades ilegais e abuso</li>
          <li>Garantir a segurança e integridade da Plataforma</li>
          <li>Manter registros para fins de auditoria e conformidade</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">3.4 Comunicações</h3>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Enviar notificações sobre sua conta e atividades</li>
          <li>Informar sobre mudanças em politicas e serviços</li>
          <li>Responder a suas mensagens e dúvidas</li>
          <li>Enviar atualizações sobre novos concursos (se autorizado)</li>
        </ul>
      </div>
    </section>

    <section id="base-legal" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">4. Base Legal para Processamento de Dados</h2>
      <p class="mb-4">
        Conforme a Lei Geral de Proteção de Dados Pessoais (LGPD), o processamento de seus dados é baseado em:
      </p>
      <ul class="list-disc pl-6 mb-4 space-y-2">
        <li><strong>Consentimento:</strong> Você expressamente consentiu com o processamento (Art. 7º, I da LGPD)</li>
        <li><strong>Contrato:</strong> Necessário para a execução de contrato com você (Art. 7º, V da LGPD)</li>
        <li><strong>Obrigação Legal:</strong> Requerido por lei para cumprir com regulamentações (Art. 7º, II da LGPD)</li>
        <li><strong>Interesses Legítimos:</strong> Necessário para proteger nossos interesses legítimos (Art. 7º, IX da LGPD)</li>
        <li><strong>Exercício de Direitos:</strong> Necessário para o exercício regular de direitos (Art. 7º, VI da LGPD)</li>
      </ul>
    </section>

    <section id="compartilhamento" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">5. Compartilhamento de Dados Pessoais</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">5.1 Compartilhamento com Terceiros</h3>
        <p class="mb-4">
          Seus dados pessoais podem ser compartilhados com:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li><strong>Órgãos Públicos:</strong> Quando solicitado por entidades governamentais ou conforme exigido por lei</li>
          <li><strong>Organizadoras de Concursos:</strong> Para processamento de inscrições e comunicações sobre concursos</li>
          <li><strong>Provedores de Serviços:</strong> Empresas que processam dados em nosso nome (pagamentos, hospedagem, etc.)</li>
          <li><strong>Parceiros Confiáveis:</strong> Empresas parceiras para prestação de serviços complementares</li>
          <li><strong>Autoridades Competentes:</strong> Se requerido por lei ou para proteger direitos, segurança e propriedade</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">5.2 Não Venda de Dados</h3>
        <p class="mb-4">
          Você tem direito de saber que NÃO vendemos seus dados pessoais para terceiros por nenhuma razão.
          Seu consentimento é sempre necessário para compartilhamento.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">5.3 Acordos de Processamento de Dados</h3>
        <p class="mb-4">
          Quando compartilhamos dados com terceiros, celebramos contratos que garantem que seus dados sejam
          processados apenas conforme autorizado e com as mesmas proteções descritas nesta Política.
        </p>
      </div>
    </section>

    <section id="retencao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">6. Retenção de Dados</h2>
      <p class="mb-4">
        Retemos seus dados pessoais pelo tempo necessário para:
      </p>
      <ul class="list-disc pl-6 mb-4 space-y-2">
        <li>Fornecer os serviços solicitados</li>
        <li>Cumprir com obrigações legais</li>
        <li>Resolver disputas e questões</li>
        <li>Estabelecer, exercer ou defender ações legais</li>
      </ul>
      <p class="mb-4">
        Após o fim da relação com você, podemos manter seus dados por período adicional conforme exigido por lei,
        geralmente até 5 (cinco) anos para fins de auditoria e conformidade. Você pode solicitar a exclusão de seus
        dados a qualquer momento, sujeito a limitações legais.
      </p>
    </section>

    <section id="protecao" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">7. Proteção de Dados</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">7.1 Medidas de Segurança</h3>
        <p class="mb-4">
          Implementamos medidas técnicas e organizacionais apropriadas para proteger seus dados pessoais contra:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Acesso não autorizado</li>
          <li>Alteração não autorizada</li>
          <li>Destruição acidental ou não autorizada</li>
          <li>Perda ou divulgação não autorizada</li>
        </ul>
        <p class="mb-4">
          Essas medidas incluem:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Criptografia de dados em trânsito e em repouso (SSL/TLS)</li>
          <li>Firewalls e sistemas de prevenção de intrusão</li>
          <li>Controle de acesso baseado em funções</li>
          <li>Monitoramento contínuo de segurança</li>
          <li>Testes de penetração regulares</li>
          <li>Políticas de segurança para funcionários</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">7.2 Limitações de Segurança</h3>
        <p class="mb-4">
          Embora utilizemos medidas de segurança adequadas, nenhum sistema é completamente seguro. Enquanto nos
          esforçamos para proteger seus dados, não podemos garantir segurança absoluta. Você usa a Plataforma
          por sua conta e risco.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">7.3 Responsabilidade do Usuário</h3>
        <p class="mb-4">
          Você é responsável por manter a confidencialidade de suas credenciais de login. Se suspeitar de acesso
          não autorizado à sua conta, notifique-nos imediatamente. Você concorda em não compartilhar sua senha com terceiros.
        </p>
      </div>
    </section>

    <section id="transferencia" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">8. Transferência Internacional de Dados</h2>
      <p class="mb-4">
        Seus dados podem ser transferidos, armazenados e processados em países diferentes do Brasil. Quando seus dados
        são transferidos internacionalmente, implementamos salvaguardas apropriadas para garantir o mesmo nível de proteção,
        incluindo Cláusulas Contratuais Padrão da União Europeia, onde aplicável.
      </p>
    </section>

    <section id="cookies" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">9. Cookies e Tecnologias de Rastreamento</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">9.1 O Que São Cookies</h3>
        <p class="mb-4">
          Cookies são pequenos arquivos de texto armazenados em seu dispositivo que permitem que a Plataforma
          reconheça você em visitas futuras.
        </p>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">9.2 Tipos de Cookies Utilizados</h3>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li><strong>Cookies Essenciais:</strong> Necessários para o funcionamento básico da Plataforma</li>
          <li><strong>Cookies de Desempenho:</strong> Ajudam-nos a entender como você usa a Plataforma</li>
          <li><strong>Cookies de Funcionalidade:</strong> Lembram suas preferências e escolhas</li>
          <li><strong>Cookies de Marketing:</strong> Utilizados para rastrear campanhas publicitárias</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">9.3 Gerenciamento de Cookies</h3>
        <p class="mb-4">
          Você pode controlar cookies através das configurações do seu navegador. A maioria dos navegadores permite
          que você recuse cookies ou o alerte quando um site tenta armazenar um cookie. No entanto, recusar cookies
          pode afetar o funcionamento da Plataforma.
        </p>
      </div>
    </section>

    <section id="direitos" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">10. Seus Direitos Conforme a LGPD</h2>
      <p class="mb-4">
        Sob a Lei Geral de Proteção de Dados Pessoais (LGPD), você tem os seguintes direitos:
      </p>
      <ul class="list-disc pl-6 mb-4 space-y-2">
        <li>
          <strong>Direito de Confirmação (Art. 15):</strong> Solicitar confirmação se seus dados estão sendo processados
        </li>
        <li>
          <strong>Direito de Acesso (Art. 18):</strong> Acessar seus dados pessoais de forma clara e em linguagem acessível
        </li>
        <li>
          <strong>Direito de Retificação (Art. 19):</strong> Corrigir dados imprecisos ou incompletos
        </li>
        <li>
          <strong>Direito à Exclusão (Art. 17):</strong> Solicitar exclusão de seus dados (direito ao esquecimento)
        </li>
        <li>
          <strong>Direito de Limitação (Art. 20):</strong> Solicitar limitação do processamento de seus dados
        </li>
        <li>
          <strong>Direito à Portabilidade (Art. 20):</strong> Receber seus dados em formato estruturado e transportável
        </li>
        <li>
          <strong>Direito de Oposição (Art. 21):</strong> Opor-se ao processamento de seus dados em determinadas circunstâncias
        </li>
        <li>
          <strong>Direito a Não Sofrer Decisões Automatizadas (Art. 20):</strong> Não ser submetido a decisões baseadas apenas em processamento automatizado
        </li>
      </ul>
      <p class="mb-4 mt-4">
        Para exercer qualquer desses direitos, entre em contato conosco através dos dados de contato fornecidos na seção 13.
      </p>
    </section>

    <section id="consentimento" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">11. Consentimento</h2>
      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">11.1 Como Obtemos Consentimento</h3>
        <p class="mb-4">
          Obtemos seu consentimento para o processamento de dados pessoais através de:
        </p>
        <ul class="list-disc pl-6 mb-4 space-y-2">
          <li>Banners de consentimento de cookies</li>
          <li>Aceitar os Termos de Uso e Política de Privacidade</li>
          <li>Formulários de opt-in específicos</li>
          <li>Outras ações claras indicando consentimento</li>
        </ul>
      </div>

      <div class="mb-4">
        <h3 class="text-xl font-semibold mb-2">11.2 Retirada de Consentimento</h3>
        <p class="mb-4">
          Você pode retirar seu consentimento a qualquer momento, sem afetar a legalidade do processamento anterior.
          Para retirar o consentimento, entre em contato conosco conforme indicado na seção 13.
        </p>
      </div>
    </section>

    <section id="menores" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">12. Menores de Idade</h2>
      <p class="mb-4">
        A Plataforma não é destinada a menores de 18 (dezoito) anos. Não coletamos intencionalmente dados pessoais de menores.
        Se descobrirmos que coletamos dados de um menor, eliminaremos esses dados assim que possível. Os pais ou responsáveis
        legais podem entrar em contato conosco para solicitar a exclusão de dados de menores.
      </p>
    </section>

    <section id="contato" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">13. Contato e Encarregado de Proteção de Dados</h2>
      <p class="mb-4">
        Para questões relacionadas à privacidade, proteção de dados ou para exercer seus direitos LGPD, entre em contato:
      </p>
      <div class="bg-gray-50 p-6 rounded-lg my-4">
        <p class="mb-2"><strong>Encarregado de Proteção de Dados (DPO)</strong></p>
        <p class="mb-2"><strong>E-mail:</strong> contato&#64;zoomeduca.com.br</p>
        <p class="mb-2"><strong>Telefone:</strong> +55 (86) 9 9981-2204</p>
        <!-- <p><strong>Endereço:</strong> [Endereço completo da organização]</p> -->
      </div>
      <p class="mb-4">
        Responderemos a suas solicitações em até 30 (trinta) dias, conforme exigido pela LGPD.
      </p>
    </section>

    <section id="modificacoes" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">14. Modificações da Política</h2>
      <p class="mb-4">
        Podemos modificar esta Política de Privacidade a qualquer momento. As modificações entrarão em vigor quando
        publicadas na Plataforma. Recomendamos que você revise esta Política periodicamente. Se você não concordar com
        qualquer modificação, você pode solicitar exclusão de sua conta.
      </p>
    </section>

    <section id="lei" class="mb-8">
      <h2 class="text-2xl font-bold mt-8 mb-4">15. Lei Aplicável</h2>
      <p class="mb-4">
        Esta Política de Privacidade é regida pelas leis da República Federativa do Brasil, em especial a
        Lei Geral de Proteção de Dados Pessoais (LGPD - Lei nº 13.709/2018).
      </p>
    </section>

    <div class="bg-gray-100 p-6 rounded-lg mt-12">
      <p class="text-sm text-gray-700">
        <strong>Aviso:</strong> Esta Política de Privacidade foi elaborada em conformidade com a Lei Geral de Proteção de
        Dados Pessoais (LGPD) e outras leis de privacidade aplicáveis. Se você tiver dúvidas, entre em contato com nosso
        Encarregado de Proteção de Dados.
      </p>
    </div>
  </div>
</div>
